import React from "react";
import {List} from "../modules/Harvests";

export function HarvestsListPage() {
  return (
    <List />
  );
}
